<template>
    <div class="index-vue">
        <!-- 右侧部分 -->
        <section class="sec-right">
            <!-- 头部 -->
            <div class="top-c">
                <header>
                    <div class="h-left">
                        <!-- <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" />
                        <div class="companyName">XXX公司</div>
                        <Divider type="vertical" /> -->
                        <div class="proName">移民网站</div>
                    </div>
                    <div class="h-right">
                        <!-- <Divider type="vertical" /> -->
                        <!-- 用户头像 -->
                        <div class="user-img-c">
                            <img :src="userImg">
                        </div>
                        <!-- 下拉菜单 -->
                        <Dropdown trigger="click" @on-click="userOperate" @on-visible-change="showArrow">
                            <div class="pointer">
                                <span class="username">{{userName}}</span>
                                <Icon v-show="arrowDown" type="md-arrow-dropdown"/>
                                <Icon v-show="arrowUp" type="md-arrow-dropup"/>
                            </div>
                            <DropdownMenu slot="list">
                                <!-- name标识符 -->
                                <!-- <DropdownItem name="1">修改密码</DropdownItem> -->
                                <!-- <DropdownItem name="2">基本资料</DropdownItem> -->
                                <!-- <DropdownItem name="3">退出登陆</DropdownItem> -->
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </header>
            </div>
            <!-- 页面主体 -->
            <div class="main-content">
                <div class="view-c">
                    <router-view v-if="isShowRouter"/>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { resetTokenAndClearUser } from '../utils'

export default {
    name: 'index',
    data() {
        return {
            // 用于储存页面路径
            paths: {},
            // 当前显示页面
            currentPage: '',
            isShowRouter: true,
            arrowUp: false, // 用户详情向上箭头
            arrowDown: true, // 用户详情向下箭头
            main: null, // 页面主要内容区域
            // 面包屑
            crumbs: '主页',
            userName: '',
            userImg: '',
            // 主页路由名称
            home: 'home',
        }
    },
    mounted() {
        // 第一个标签
        const name = this.$route.name
        this.currentPage = name

        // 设置用户信息
        this.userName = localStorage.getItem('userName')
        this.userImg = localStorage.getItem('userImg')

        this.main = document.querySelector('.sec-right')
    },
    methods: {
        // 跳转页面 路由名称和参数
        gotoPage(name, params) {
            this.currentPage = name
            this.crumbs = this.paths[name]
            this.$router.push({ name, params })
        },
        // 用户操作
        userOperate(name) {
            switch (name) {
                case '1':
                    // 修改密码
                    this.gotoPage('password')
                    break
                case '2':
                    // 基本资料
                    this.gotoPage('userinfo')
                    break
                case '3':
                    resetTokenAndClearUser()
                    this.$router.push({ name: 'login' })
                    break
            }
        },
        // 控制用户三角箭头显示状态
        showArrow(flag) {
            this.arrowUp = flag
            this.arrowDown = !flag
        },
        processNameToTitle(obj, data, text) {
            if (data.name) {
                obj[data.name] = data.text
                this.paths[data.name] = text ? `${text} / ${data.text}` : data.text
            }
            if (data.children) {
                data.children.forEach(e => {
                    this.processNameToTitle(obj, e, text ? `${text} / ${data.text}` : data.text)
                })
            }
        },
    },
}
</script>

<style scoped lang="scss">
.index-vue {
    height: 100%;
    color: #666;
    background: url('../assets/imgs/bg_img@2x.png') no-repeat center / cover;

}
/* 主体页面 */
.sec-right {
    height: 100%;
    transition: margin-left .3s;
    overflow: hidden;
    background: transparent;
}
/* 主体页面头部 */
header {
    height: 50px;
    border-bottom: none;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    font-size: 14px;
}
header .ivu-icon {
    font-size: 24px;
}
.h-right {
    display: flex;
    align-items: center;
    .username{
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
    }
}
.h-left {
    display: flex;
    align-items: center;
    .companyName{
        margin: 0 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
    }
    .proName{
        margin-left: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
    }
}
.user-img-c img {
    width: 100%;
}
.user-img-c {
    width: 28px;
    height: 28px;
    background: #ddd;
    border-radius: 50%;
    margin: 0 11px 0 19px;
    overflow: hidden;
}
/* 主要内容区域 */
.main-content {
    height: calc(100% - 88px);
    overflow: hidden;
}
.view-c {
    position: relative;
    height: 100%;
    overflow: hidden;
}
.pointer {
    cursor: pointer;
}
.crumbs {
    margin-left: 10px;
    color: #97a8be;
    cursor: default;
}
.menu-level-3 .ivu-icon {
    font-size: 18px;
}
</style>